import { formatDate, CreateFechaMoment, formatDateComparator, formatDateFilter, DateComparer, stringToDate, DateTimeFormatter, DATE_FORMAT_UTC } from "../../../utils/fecha";
import { stringToFloat, toDecimalString } from "../../../utils/numbers";
import { BooleanCellRenderer } from "../../CustomCells/BooleanCellRenderer";

export const formatNumber = (params) => {
  if (params.value === null || params.value === undefined || params.value.length === 0) {
    return "";
  }

  if (typeof params.value === "string") {
    return toDecimalString(parseFloat(params.value));
  } else {
    return toDecimalString(params.value);
  }
};

export const formatInt = (params) => {
  return params.value !== null && params.value !== undefined ? parseInt(params.value) : "";
};

// export const formatDateStr = (params) => {
//   return params.value !== null && params.value !== undefined && params.value.length > 0
//     ? formatDate(CreateFechaMoment(params.value))
//     : "";
// };

const dateShortFormatter = (params) => {
  if (params.value && params.value.length > 0) {
    return DateTimeFormatter(DATE_FORMAT_UTC).format(stringToDate(params.value));
  }
  

  return params.value;
};

export const formatText = (params) => {
  return params.value === null ? "" : params.value
};

export const formatBoolToInt = (params) => {
  return params.value === true || params.value === 1 ? 1 : 0;
};

export const formatBoolToText = (params) => {
  return params.value === null ? 'null' : (params.value === true || params.value === 1 ? "Si" : "No");
};

export const numberParser = (params) =>{
  return stringToFloat(params.newValue);
}

export const getComparatorDate = (filterLocalDateAtMidnight, cellValue) => {
  const date = new Date(cellValue);
  date.setHours(0, 0, 0, 0);
  if (date < filterLocalDateAtMidnight) {
    return -1;
  } else if (date > filterLocalDateAtMidnight) {
    return 1;
  } else {
    return 0;
  }
};

const dateComparator = (filterDate, cellValue) => {
  if (cellValue === null) {
  return 0;
}

const cellDate = stringToDate(cellValue);  

  return  DateComparer(cellDate, filterDate);
};

export const hasTotalColumns = (columnDefs) => columnDefs.some((c) => c.ipkTotalizar);
export const getTotalColumnsDefs = (columnDefs) => columnDefs.filter((c) => c.ipkTotalizar);
export const extractPinnedBottomDataSchema = (columnDefs) => {
  return getTotalColumnsDefs(columnDefs).reduce((p, c) => {
    p[c.field] = c.ipkDefaultValue;
    return p;
  }, {});
};

const filterOptions = [
  //'empty',
  // {
  //     displayKey: 'Sin Fecha',
  //     displayName: 'Sin Fecha',
  //     test: function (filterValue, cellValue) {
  //         return cellValue === null;
  //     },
  //     //hideFilterInput: true,
  // },
  'equals',
  'notEqual',
  'lessThan',
  'lessThanOrEqual',
  'greaterThan',
  'greaterThanOrEqual',
  'inRange'
];

const TEXT_COLUMN = {
  editable: false,
  sortable: true,
  type: "",
  hide: false,
  filter: "agTextColumnFilter",
  suppressMenu: true,
  valueFormatter: formatText,
  ipkDefaultValue: String(),
  ipkTotalizar: false,
  resizable:true,
  filterParams: {newRowsAction: 'keep'}
};
const NUMERIC_COLUMN = {
  editable: false,
  sortable: true,
  valueFormatter: formatInt,
  type: "numericColumn",
  hide: false,
  filter: "agNumberColumnFilter",
  suppressMenu: true,
  ipkDefaultValue: Number(),
  ipkTotalizar: false,
  valueParser: numberParser,
  filterParams: {newRowsAction: 'keep'}
};
const DECIMAL_COLUMN = {
  editable: false,
  sortable: true,
  valueFormatter: formatNumber,
  type: "numericColumn",
  hide: false,
  filter: "agNumberColumnFilter",
  suppressMenu: true,
  ipkDefaultValue: Number(),
  ipkTotalizar: true,
  valueParser: numberParser,
  filterParams: {newRowsAction: 'keep'}
};

const DATE_COLUMN = {
  valueFormatter: dateShortFormatter,
  sortable: true,
  cellStyle: { textAlign: "left" },
  editable: false,
  filter: "agDateColumnFilter",
  type: "dateColumn",
  suppressMenu: true,
  filterParams:{ resetButton: true, filterOptions: filterOptions, newRowsAction: 'keep',comparator: getComparatorDate },
  ipkDefaultValue: String(),
  ipkTotalizar: false,
  //filterParams: {newRowsAction: 'keep'}
  //comparator: dateComparator
};

const BOOLEAN_COLUMN = {
  editable: false,
  sortable: true,
  valueFormatter: formatBoolToText,
  type: "",
  hide: false,
  filter: "agTextColumnFilter",
  suppressMenu: true,
  ipkTotalizar: false,
  cellStyle: { "text-align": "center" },
  cellRendererFramework: BooleanCellRenderer,
  floatingFilterComponent: 'SiNoFilter',
  floatingFilterComponentParams: {
    suppressFilterButton: true
  },
  filterParams: {newRowsAction: 'keep'}
};

const POPOVER_COLUMN = {
  editable: false,
  sortable: false,
  valueFormatter: "",
  type: "",
  hide: false,
  suppressMenu: true,
  ipkTotalizar: false,
  cellStyle: { "text-align": "center" }
}


export const ColumnsFactory = {
  TextColumn: (headerName, field, extra) => {
    return extra === undefined
      ? { ...TEXT_COLUMN, headerName: headerName, field: field }
      : { ...TEXT_COLUMN, headerName: headerName, field: field, ...extra};
  },
  NumericColumn: (headerName, field, extra) => {
    return extra === undefined
      ? { ...NUMERIC_COLUMN, headerName: headerName, field: field }
      : { ...NUMERIC_COLUMN, headerName: headerName, field: field, ...extra };
  },
  DecimalColumn: (headerName, field, extra) => {
    return extra === undefined
      ? { ...DECIMAL_COLUMN, headerName: headerName, field: field }
      : { ...DECIMAL_COLUMN, headerName: headerName, field: field, ...extra };
  },
  DateColumn: (headerName, field, extra) => {
    return extra === undefined
      ? { ...DATE_COLUMN, headerName: headerName, field: field }
      : { ...DATE_COLUMN, headerName: headerName, field: field, ...extra };
  },
  BooleanColumn: (headerName, field, extra) => {
    return extra === undefined
      ? { ...BOOLEAN_COLUMN, headerName: headerName, field: field }
      : { ...BOOLEAN_COLUMN, headerName: headerName, field: field, ...extra };
  },
  PopoverColumn: (headerName, field, extra) => {
    return extra === undefined
      ? { ...POPOVER_COLUMN, headerName: headerName, field: field }
      : { ...POPOVER_COLUMN, headerName: headerName, field: field, ...extra };
  },
  GroupColumn: (headerName, children, className) =>{
    return {headerName: headerName, children: children, ...(className?{headerClass: className}:{})}
  }
};
